import { Link } from "react-router-dom";
import {
  facebook,
  linkedin,
  whatsapp,
  login,
  tiktok,
  twitter,
} from "../assets/icons/index";
import {
  ABOUT_PATH,
  CONTACT_PATH,
  HOME_PATH,
  SERVICES_PATH,
} from "../Routes/paths";
import LangButton from "./LangButton";
import { useTranslation } from "react-i18next";

interface HeaderProps {}

const Header = ({}: HeaderProps) => {
  const { i18n, t } = useTranslation();
  return (
    <>
      <section
        className={`w-full h-[80px]  flex items-center justify-around ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* logo ************************/}
        <Link to={HOME_PATH}>
          <img
            className="w-[90px] lg:w-[140px]"
            src="../images/logo.png"
            alt=""
          />
        </Link>

        {/* nav bar  ********************/}
        <div className="flex items-center gap-2 lg:gap-10 text-[12px] lg:text-[18px]">
          <Link to={ABOUT_PATH} className="hover:text-first_color">
            {t("About Us")}
          </Link>
          <Link to={SERVICES_PATH} className="hover:text-first_color">
            {t("Services")}
          </Link>
          <Link to={CONTACT_PATH} className="hover:text-first_color">
            {t("Contact Us")}
          </Link>
        </div>

        {/* social icon  ****************/}
        <div className="flex items-center gap-3">
          <div className="hidden lg:flex items-center lg:gap-4">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/profile.php?id=61563989890756"
            >
              <img
                className="w-[10px] hover:scale-125 duration-150 cursor-pointer"
                src={facebook}
                alt=""
              />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/onyxcom-tech-6ba269337/"
            >
              <img
                className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
                src={linkedin}
                alt=""
              />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/+971524344578"
            >
              <img
                className="w-[18px] hover:scale-125 duration-150 cursor-pointer"
                src={whatsapp}
                alt=""
              />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.tiktok.com/@onyxcomtech?lang=en"
            >
              <img
                className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
                src={tiktok}
                alt=""
              />
            </a>

            <a
              target="_blank"
              rel="noreferrer"
              href="https://x.com/OnyxcomTech"
            >
              {" "}
              <img
                className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
                src={twitter}
                alt=""
              />
            </a>
          </div>

          <div>
            <button className="hidden w-[85px] h-[40px] rounded-[12px] bg-[#E4002F] text-white lg:text-[14px] lg:flex items-center justify-center gap-1">
              <img src={login} alt="" />
              {t("Login")}
            </button>
          </div>
        </div>

        {/* moblie view  */}
      </section>
      <div className="w-full px-[20px] lg:px-[10%] flex items-center lg:justify-end justify-between">
        <LangButton />

        <div className="flex lg:hidden items-center gap-4">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/profile.php?id=61563989890756"
          >
            <img
              className="w-[10px] hover:scale-125 duration-150 cursor-pointer"
              src={facebook}
              alt=""
            />
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/onyxcom-tech-6ba269337/"
          >
            <img
              className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
              src={linkedin}
              alt=""
            />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://wa.me/+971524344578"
          >
            <img
              className="w-[18px] hover:scale-125 duration-150 cursor-pointer"
              src={whatsapp}
              alt=""
            />
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.tiktok.com/@onyxcomtech?lang=en"
          >
            <img
              className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
              src={tiktok}
              alt=""
            />
          </a>

          <a target="_blank" rel="noreferrer" href="https://x.com/OnyxcomTech">
            {" "}
            <img
              className="w-[20px] hover:scale-125 duration-150 cursor-pointer"
              src={twitter}
              alt=""
            />
          </a>
        </div>

        <button className="lg:hidden w-[85px] h-[40px] rounded-[12px] bg-[#E4002F] text-white lg:text-[14px] flex items-center justify-center gap-1">
          <img className="mt-[2px]" src={login} alt="" />
          {t("Login")}
        </button>
      </div>
    </>
  );
};

export default Header;
